import useDeposit from '#app/View/InventoryManagement/Inventory/DepositInventory/hooks/useDeposit';
import DepositEntryPoints from '#app/entrypoints/deposit';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { InventoryInfo } from '#app/typings/deposit';

export type Filters = {
  marks?: string[];
  withStock?: boolean;
};

type HookReturn = ReturnType<typeof useCollectionPaginated<InventoryInfo, Filters>>;

const useInventory = (filters?: Filters): HookReturn => {
  const { deposit } = useDeposit();

  return useCollectionPaginated<InventoryInfo, Filters>(
    deposit ? DepositEntryPoints.getInventoryInfo : undefined,
    {
      filters: filters ?? {},
      sorting: {},
    },
    { deposit: deposit },
  );
};

export default useInventory;
